export class CustomerInternet {
	id?: string;
	description?: string;
	address?: string;
}
